import { LeafAccordionPanelInline } from "./accordion-panel-inline.component.js";
customElements.define("leaf-accordion-panel-inline", LeafAccordionPanelInline);
export {
  LeafAccordionPanelInline
};
//# sourceMappingURL=accordion-panel-inline.js.map
